<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Các sản phẩm phù hợp</h4>
			<!-- <p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4" role="alert">
				<p class="font-bold">Ghi chú</p>
				<p>
					- Nếu giá mua lớn hơn giá bán thì giá giao dịch là giá bán <br/>
					- Nếu khối lượng bên bán không đủ đáp ứng thì đơn mua sẽ được tách ra <br/>
					- Nếu khối lượng bên bán nhiều hơn khối lượng bên mua thì khối lượng giao dịch là khối lượng cần mua <br/>
					- Nếu là đơn bán nguyên lô thì khối lượng mua sẽ thay đổi thành khối lượng của bên bán (dấu <span class="text-danger">*</span> màu đỏ)
				</p>
			</div>
			<vs-table :sst="true" class="shadow-none border-none custom-vs-table" fixed responsive :data="shippings">
				<template slot="thead">
					<vs-th>STT</vs-th>
					<vs-th>Khối lượng</vs-th>
					<vs-th>Đơn giá</vs-th>
					<vs-th>Giá VC dự kiến</vs-th>
					<vs-th>Giá dự kiến</vs-th>
					<vs-th></vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow(tr)">
						<vs-td>
							{{indextr+1}} (#{{tr.id}} <span class="text-danger" v-if="tr.prevent_slit">*</span>)
							<div class="extra-info">{{(canSeeSupllier || tr.buy_id == id) ? tr.supplier_name : 'NCC: ***'}}</div>
						</vs-td>
						<vs-td>{{$helper.numFormat(tr.quantity)}}</vs-td>
						<vs-td>{{$helper.numFormat(tr.price)}}</vs-td>
						<vs-td v-html="displayShippingInfo(tr.shipping_forecast, 1, 0)"></vs-td>
						<vs-td v-html="displayShippingInfo(tr.shipping_forecast, 2, tr.price)"></vs-td>
						<vs-td>
							<div v-if="tr.status < 2 && status < 2" id="test" style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" @click.stop="confirmBuy(tr, $event)">
								<!--<i class="nucleo mr-1 text-primary nucleo-file-text" />-->
								<span class="label text-primary">Mua</span>
							</div>
							<label v-if="(tr.status==2 || tr.status==4 || tr.status==64 || tr.status==128 || tr.status==2056) && tr.buy_id == id">Đã mua</label>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
			<div style="height:30px;"></div>
		</PerfectScrollbar>

		<!--<div class="flex justify-center" slot="footer" v-if="canDoneShipping && !shipping_done">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >Hoàn thành vận đơn</vs-button>
		</div>-->
		<OrderDetail :isPopupActive="isDetailUserDialogActive" @closePopup="toggleDetailSidebar" :data="detailUserDialogData" />
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import OrderDetail from "./OrderDetail.vue";
import Helper from "../../../utils/helpers.js";

export default {
	name: "KcsForm",
	components: { vSelect, OrderDetail },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			timeKey: Date.now(),
			id: null,
			status: 0,
			product_name: null,
			quantity: null,
			supplier_name: null,
			supplier_phone: null,
			supplier_address: null,
			shipping_done: false,
			shippings: [],

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			isDetailUserDialogActive: false,
			detailUserDialogData: {},
			canCreateShipping: false,
			canDoneShipping: false,
			canSeeSupllier: false,
			isKcsRatingDialogActive: false,
			kcsRatingDialogData: {},
			buy_address: '',
			userToken: '',
		};
	},
	watch: {
		isPopupActive(val) {
			console.log('isPopupActive: ', val);
			if (!val) return;

			const { id, status } = this.data;

			if (id) {
				this.id = id;
				this.getMatching();
			} else {
				this.id = null;
			}
			this.status = status;

			this.isFormDirty = false;
			this.initFormData = {};
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
		city() {
			if (this.city) {
				this.$store.dispatch("getDistrict", {
					provinceCode: this.city,
				});
			}
		},
		district() {
			if (this.district) {
				this.$store.dispatch("getWard", {
					districtCode: this.district,
				});
			}
		},
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		// computedFormData() {
		// 	return {
		// 		id: this.id,
		// 		fullName: this.fullName,
		// 		nickname: this.nickname,
		// 		phone: this.phone,
		// 		city: this.city,
		// 		district: this.district,
		// 		ward: this.ward,
		// 		street: this.street,
		// 		assigned: this.assigned,
		// 		totalPool: this.totalPool,
		// 	};
		// },
	},
	created() {
		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { shipping_can_create = false, shipping_can_done = false, shipping_can_rating = false } = permissions;
			if (shipping_can_create) {
				this.canCreateShipping = true;
			}
			if (shipping_can_done) {
				this.canDoneShipping = true;
			}
			if (shipping_can_rating) {
				this.canRatingShipping = true;
			}
			this.userToken = token;
		}
	},
	methods: {
		displayShippingInfo(forecast, type, price) {
			let str = '';
			for (let k in forecast) {
				if (forecast[k]) {
					str += `${k == 1 ? 'Xe' : 'Ghe'}: ${type == 1 ? forecast[k] : Helper.numFormat(parseFloat(price) + parseFloat(forecast[k]))} <br />`;
				}
			}
			return str;
		},
		confirmBuy(item) {
			// console.log(item);
			let color = "success";
			let msg = 'Đồng ý mua lệnh có giá '+item.price;
			if (item.prevent_slit) {
				color = 'warning';
				msg = 'Lưu ý, lệnh này chỉ bán nguyên lô';
			}
			this.$vs.dialog({
				type: "confirm",
				color: color,
				title: this.$t("Actions.Confirm"),
				text: msg,
				// accept: () => this.deleteCustomer(customer._id),
				accept: () => this.okBuy(item),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
        },
		okBuy(sell) {
			// this.$vs.loading();
			try {
				let payload = {
					id: this.id,
					sell_id: sell.id,
					sell_price: sell.price,
					shipping_forecast: sell.shipping_forecast
				};
				this.$store.dispatch("moduleProduct/confirmBuy", payload).then(response => {
					if (response) {
						if (response.hasOwnProperty('error')) {
							this.$helper.notifyError({
								context: this,
								options: {
									text: response.error,
								},
							});
						} else {
							this.$helper.notifySuccess({
								context: this,
								options: {
									text: response.data || '???',
								},
							});
							this.status = 2;
							this.shippings.map(item => {
								if (item.id == sell.id) {
									item.status = 2;
									item.buy_id = this.id; // trick to show bought
								}
							})
						}
					}
				});
				// this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleClickItemRow(item) {
			console.log('item: ', item);
			// if (this.canCreateShipping) {
				this.detailUserDialogData = item;
				this.isDetailUserDialogActive = true;
			// } else if (this.canRatingShipping) {
			// 	this.kcsRatingDialogData = item;
			// 	this.isKcsRatingDialogActive = true;
			// }
		},
		toggleKcsSidebar() {
			this.isKcsRatingDialogActive = !this.isKcsRatingDialogActive;
		},
		toggleDetailSidebar() {
			this.isDetailUserDialogActive = !this.isDetailUserDialogActive;
			if (!this.isDetailUserDialogActive) {
				this.getMatching();
			}
		},
		toogleAddShipping() {
			this.isDetailUserDialogActive = !this.isDetailUserDialogActive;
			this.detailUserDialogData = {
				match_id: this.id,
				buy_address: this.buy_address,
			};
		},
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		getMatching() {
			this.id = this.data ? this.data.id : null;
			if (!this.id) {
				return;
			}
			// this.$vs.loading();
			try {
				this.$store.dispatch("moduleProduct/getMatchingSells", this.id).then(response => {
					console.log('response: ', response);
					this.shippings = response;

				}).catch(err => console.log);
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						id: this.id,
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			if (this.supplier == 0) {
				this.getSuppliers();
			}
			if (!this.id) {
				this.initValues();
			}
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đã lưu hoàn thành vận đơn",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/doneShipping", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>

<style>
.extra-info {

    font-size: 8px;

}
</style>